import request from '@/utils/changanRequest'
// 便民资讯
export function trealinfoPage (query) {
  return request({
    url: 'system/trealinfo/wechat/list',
    method: 'get',
    params: query
  })
}
// 便民资讯详情
export function trealinfoDetails (query) {
  return request({
    url: '/system/trealinfo/'+query,
    method: 'get',
  })
}
// 便民资讯分类
export function GetInfoKindInfoPage(params) {
  return request({
    url: "system/tinfokind/list",
    method: "get",
    params,
  });
}
// 保存社区动态
export const SaveRlInfo = (data) => {
  return request({
    url: 'system/trealinfo',
    method: 'post',
    data
  })
}
